import { PageHeader } from "../components/helpers";

const About = () => {
	return (
		<>
			<PageHeader />

			<div className="content-width headerPadding marginTop-xlarge">
				<section className="summary plusPattern marginBottom-xlarge text-center">
					<p>
						KPP Architects are an <b>award-winning architectural practice;</b> based in Leeds since 1969, providing full Architectural services in connection with a
						wide range of projects throughout the U.K.
					</p>

					<p>
						Led by the practice's directors, our <b>collaborative approach</b> empowers the collective dialogue that has shaped the practice for over 60 years, a
						dialogue which has <b>the client at its centre</b> and the experience of the KPP team supporting it.
					</p>

					<p>
						The Practice offers a <b>comprehensive range of services</b> including development strategies, master-planning, full architectural service, interior design
						and visuals. We have experience in multiple building sectors to <b>deliver small scale and multi-million pound projects</b> for Industrial, Heritage, Health
						Care, Retail & Leisure, Workplace, Education and Residential projects. We combine our design skill and technical knowledge to deliver high quality projects
						for our clients, being <b>innovative and progressive</b> in our approach, from concept layout to construction detailing.
					</p>

					<p>
						Our award-winning architecture is supported by a commercial and considered approach to tackling a client's brief, this involves multi-disciplinary,
						collaborative working, within a wider team framework, liaising closely with the client to ensure their aspirations and objectives are being delivered.
					</p>
				</section>

				<section>
					<header>
						<h2>Meet the Team</h2>
					</header>
					<p>
						We believe in positive working relationships with our clients, the wider project team and in-house. This forms the foundation to fully integrated and
						coordinated projects. To this end, all projects are assigned a designated team of experienced personnel, led by a Director, providing consistency for the
						client and wider project team.
					</p>
					<p>
						At the outset of a project we establish the key elements of the client's objectives to deliver an efficient, comprehensive project. We consider factors
						which may affect the deliverability of the scheme, impacting on layout, density, design, viability, sustainability etc. Often this requires
						multi-disciplinary involvement in the early stages of a project, engaging with Statutory Authorities and other professionals in a staged approach, to manage
						the expenditure of up-front costs and to ensure the long-term goals of the project are met effectively and successfully.
					</p>
				</section>

				<section className="grid-wrapper columns-2 marginTop-large paddingInline-none">
					<div className="backgroundColor-kppCream padding-medium">
						<header className="marginBottom-medium">
							<h3>Rachel Slater, Director</h3>
							<span>BA (Hons) BArch RIBA</span>
						</header>
						<p>Rachel began her career at KPP as a graduate architect in 2001, rising though the practice to become a Director in 2008.</p>
						<p>
							Her architectural flair is balanced by a depth of understanding of detailing and construction methods, ensuring a project can be realised, even at
							concept stage. Rachel is an extremely versatile architect, having worked in most sectors (industrial, residential, healthcare, education, conservation,
							etc) and her knowledge base is extensive.
						</p>
						<ul className="marginTop-medium">
							<li>Bachelor of Arts Degree in Architecture</li>
							<li>Bachelor of Architecture Degree</li>
							<li>Member of the Architects Registration Board</li>
							<li>Chartered member of the Royal Institute of British Architects (RIBA)</li>
						</ul>
					</div>

					<div className="backgroundColor-kppCream padding-medium">
						<header className="marginBottom-medium">
							<h3>James McDermott, Director</h3>
							<span>BSc Arch Tech, MCIAT</span>
						</header>
						<p>James has worked at KPP for over 25 years and became a director in 2016.</p>
						<p>
							He has experience in project management, design and delivering projects to site. This includes a wide range of projects, including industrial,
							commercial, residential and conservation projects, contributing to a diverse understanding of the built environment and a broad palette of construction
							design.
						</p>
						<ul className="marginTop-medium">
							<li>Bachelor of Science Degree in Architecture Technology</li>
							<li>Member of Chartered Institute of Architectural Technology</li>
						</ul>
					</div>
				</section>

				{/* <section className="grid-wrapper columns-3 marginTop-large marginBottom-xlarge paddingInline-none">
					<div className="backgroundColor-kppCharcoal fontColour-cream padding-medium">
						<header className="marginBottom-medium">
							<h3>Nick Jones, Associate</h3>
							<span>BSc (Hons) PG Dip Arch RIBA</span>
						</header>
						<p>Nick Joined KPP Architects in 2010 becoming an Associate in 2018.</p>
						<p>
							Nick has worked on a broad range of projects across multiple sectors including, education, commercial, conservation, retail and leisure, developing a
							keen interest and knowledge of refurbishment and fit-out projects, from heritage buildings to modern commercial office developments, utilising that
							knowledge and attention to detail to ensure all aspects of a project are delivered to the highest standards.
						</p>
						<ul className="marginTop-medium">
							<li>BSC (Hons) Architecture and Environmental Design</li>
							<li>PG Dip Architecture</li>
							<li>PG Dip Architectural Professional Practice</li>
							<li>Member of the Architects Registration Board</li>
							<li>Chartered Member of the Royal Institute of British Architects (RIBA)</li>
						</ul>
					</div>

					<div className="backgroundColor-kppCharcoal fontColour-cream padding-medium">
						<header className="marginBottom-medium">
							<h3>Matthew Hall, Associate</h3>
							<span>BSc Arch Tech</span>
						</header>
						<p>
							Matthew joined KPP Architects in 2014 with a degree in Architectural Technology. Since joining the Practice he has worked on a wide variety of projects
							from commercial, residential and industrial sectors. Starting as a junior technician, Matthew has progressed to the position of Associate, managing
							projects on site and working closely with clients and contractors throughout the development to achieve the desired outcome. Matthew has experience in
							multi-year developments including the ongoing regeneration of the historic award- winning Sunny Bank Mills in Farsley, as well as delivering the roll
							out of varying scales of industrial developments around Yorkshire, providing a diverse portfolio of experience.
						</p>
						<ul className="marginTop-medium">
							<li>Bachelor of Science Degree in Architectural Technology</li>
						</ul>
					</div>

					<div className="backgroundColor-kppCharcoal fontColour-cream padding-medium">
						<header className="marginBottom-medium">
							<h3>Sam Frain, Associate</h3>
							<span>BSc Arch Tech, MCIAT</span>
						</header>
						<p>
							Sam joined KPP in 2015 as a trainee technician, following the completion of his degree in Architectural Technology and has since become an Associate.
							Sam has experience across multiple sectors including residential, refurbishment, commercial and primarily the industrial and logistics sector. Sam has a
							proven track record in delivering projects from concept through to completion, regularly working closely with a variety of project stakeholders from
							clients and contractors to regulatory professionals. Being at the heart of the project team for multiple projects, Sam has delivered many projects to
							high standards.
						</p>
						<ul className="marginTop-medium">
							<li>Bachelor of Science Degree in Architectural Technology</li>
							<li>Member of The Chartered Institute of Architectural Technology</li>
						</ul>
					</div>

					<div className="backgroundColor-kppCharcoal fontColour-cream padding-medium">
						<header className="marginBottom-medium">
							<h3>Alex Buller, Associate</h3>
							<span>BSc Arch Tech</span>
						</header>
						<p>
							Alex joined KPP Architects in 2013 as part of his university placement year. After completing his architectural studies in 2016, he continued to grow in
							knowledge and experience within the Practice and became an Associate in 2023. Alex has built a strong portfolio of work in the commercial and industrial
							sectors, with extensive experience leading projects from early concept design through to delivery on site, with a particular focus on large scale
							industrial buildings. This has included creating a number of good relationships with key clients, to ensure the client's needs are met and there is
							trust in the delivery information. Known also for his practical approach and attention to detail, Alex plays a key role in turning ambitious design
							ideas into successful outcomes
						</p>
						<ul className="marginTop-medium">
							<li>Bachelor of Science Degree in Architectural Technology</li>
						</ul>
					</div>

					<div className="backgroundColor-kppCharcoal fontColour-cream padding-medium">
						<header className="marginBottom-medium">
							<h3>Dan Russell, Associate</h3>
							<span>Ba(Hons) MArch, RIBA</span>
						</header>
						<p>
							Dan joined KPP in 2016 after completing his master's degree in architecture and became an Associate in 2023. During his time at KPP Dan has worked
							across a wide range of project types with a particular focus on the commercial and industrial sectors. Dan has a keen eye for detail and thrives on
							delivering innovative designs within the commercial constraints of a project. Dan takes a lead role in delivering projects with particular skill in
							translating a client's initial vision into a successful completed project.
						</p>
						<ul className="marginTop-medium">
							<li>BA(Hons) Architecture</li>
							<li>PG Master of Architecture</li>
							<li>PG Dip Architectural Professional Practice,</li>
							<li>Member of the Architects Registration Board</li>
							<li>Chartered member of the Royal Institute of British Architects (RIBA)</li>
						</ul>
					</div>
				</section> */}
			</div>
		</>
	);
};

export default About;
